<template>
  <div
    class="group  rounded-extra-small last:rounded-b-large relative flex cursor-pointer flex-row overflow-hidden border px-2 py-2"
    :class="[
      isSelected && 'rounded-large! bg-secondary-container! border-secondary',
      !isSelected && 'bg-surface-container-low border-surface-container-high',
    ]"
  >
    <BaseMemberAvatar v-if="member" size="32" class="mt-0.5" :member="member" />
    <div
      v-else
      class="mt-0.5 flex h-8 w-8 shrink-0 items-center justify-center rounded-full"
      :class="[
        isSelected && 'bg-primary text-on-primary',
        !isSelected && 'bg-primary-container text-on-primary-container',
      ]"
    >
      <BaseIcon size="20">person</BaseIcon>
    </div>
    <div class="ml-3 flex flex-col pr-2">
      <div class="text-label-small text-on-surface-variant w-full font-normal">
        <span v-if="member">{{ memberFullName(member) }} ・ </span>
        <span v-if="date">
          {{ useDisplayDate(date, { dayName: 'none', monthName: 'short' }) }}
        </span>
      </div>
      <WysiwygTextFieldReadOnly :value="text" />
    </div>
    <BaseCheckbox :is-checked="isSelected" class="mt-2 ml-auto" />
    <BaseStateLayer />
  </div>
</template>
<script lang="ts" setup>
  import type { JSONContent } from '@tiptap/vue-3'
  import type { MemberOrUser } from '@/core/models/member/member-or-user'
  import { memberFullName } from '@/core/models/member/member-name'
  import BaseMemberAvatar from '@/core/components/base/avatar/BaseMemberAvatar.vue'
  import BaseIcon from '@/core/components/base/icon/BaseIcon.vue'
  import { useDisplayDate } from '@/core/composables/use-display-date'
  import WysiwygTextFieldReadOnly from '@/core/components/base/wysiwyg/WysiwygTextFieldReadOnly.vue'
  import BaseStateLayer from '@/core/components/base/state-layer/BaseStateLayer.vue'
  import BaseCheckbox from '@/core/components/base/checkbox/BaseCheckbox.vue'

  interface Props {
    member?: MemberOrUser
    date?: string
    text: JSONContent
    isSelected: boolean
  }

  defineProps<Props>()
</script>
